export default __webpack_public_path__ + "static/media/viva.188ea62a.png";